var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 25,
    viewBox: "0 0 223 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 38.0547 14.4609)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 114.164 14.4609)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 76.1094 14.4609)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 152.219 14.4609)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 95.1367 4.57031)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 171.246 4.57031)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 133.191 4.57031)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 209.301 4.57031)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 19 24.3594)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 95.1094 24.3594)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 57.0547 24.3594)",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 133.164 24.3594)",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 57.082 14.4609)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 133.191 14.4609)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 95.1367 14.4609)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 171.246 14.4609)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 76.1094 4.57031)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 152.219 4.57031)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 114.164 4.57031)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 190.273 4.57031)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 0 24.3594)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 76.1094 24.3594)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 38.0547 24.3594)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 13.6997,
    height: 4.56655,
    transform: "matrix(1 0 0 -1 114.164 24.3594)",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL1);
export default __webpack_public_path__ + "static/media/l1.996ff528b18f09aba46d34f0c98071d6.svg";
export { ForwardRef as ReactComponent };